import ResourceSvc from '@/services/resource.svc.js';
const request = new ResourceSvc();
import { EventBus } from '@/services/Event.js';

import TableData from '../table/table.vue';
import FilterBar from '../filter-bar/filter-bar.vue';
import ClubStandardLayout from '@/components/user/dashboard/pages/club-standard/layout/layout.vue';
import { Pagination as LPagination } from '@/components/index';

export default {
    name: 'ClubStandardsLayout',
    components: {
        'table-data': TableData,
        'filter-bar': FilterBar,
        'club-standard-layout': ClubStandardLayout,
        LPagination

    },
    watch: {
        filter: {
            immediate: true,
            handler(newVal, oldVal) {
                if (JSON.stringify(newVal) == JSON.stringify(oldVal)) {
                    return;
                }
                if (!oldVal) {
                    this.init();
                }
                else {
                    this.load();
                }
            }
        },
        page: {
            immediate: true,
            handler(newVal) {
                if (newVal != this.filter.options.page) {
                    this.filter.options.page = newVal;
                    this.load();
                }
            }
        },
    },
    data() {
        return {
            isProcessing: false,
            currentClubId: null,
            currentStandardType: null,
            currentClubName: null,
            currentBlockOrderNumber: null,
            tableData: [],
            filter: {
                clubName: null,
                year: null,
                standardType: null,
                blockStatus: null,
                options: { skip: 0, take: 5, perPage: 5, page: 1 }
            },
            blockStatuses: [],
            years: [],
            total: 0,
            page: 1,
            standardTypes: [],
        }
    },
    computed: {
        isNeedSupportData() {
            return !this.years.length || !this.blockStatuses.length || !this.standardTypes.length;
        },
        skip() {
            return (this.filter.options.page - 1) * this.filter.options.perPage;
        },
        take() {
            return this.filter.options.perPage;
        },
        from() {
            return this.skip + 1;
        },
        to() {
            return this.skip + this.take;
        }
    },
    methods: {
        showSuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }

            this.$notify({
                message: message,
                type: 'success',
                timeout: 1000
            });
        },
        console(message) {
            if (console && console.log) {
                if (message) {
                    console.log(message);
                }
                else {
                    const date = new Date();
                    console.log("-------> " + date.getMinutes() + ":" + date.getSeconds());
                }
            }
        },
        init() {
            this.load();
        },
        getFilter()
        {
            let filter = { ...this.filter };
            filter.options.skip = this.skip;
            filter.options.take = this.take;
            filter.isNeedSupportData = this.isNeedSupportData;

            if (!filter.clubName) {
                filter.clubName = '';
            }
            return filter;
        },
        to_top() {
            setTimeout(() => {
                window.scrollTo(105, 105);
            }, 1000)
        },
        load() {
            const self = this;
            self.isProcessing = true;
            request.getClubStandardQuestionsList(self.getFilter())
                .then(res => {
                    self.isProcessing = false;
                    if (res && res.body && res.body.isSuccess) {
                        self.tableData = res.body.outputData.items;
                        self.total = res.body.outputData.total;

                        if (self.isNeedSupportData) {
                            if (res.body.outputData.years && res.body.outputData.years) {
                                self.years = res.body.outputData.years;
                                self.years.unshift({ id: null, label: 'Any', value: null });
                            } else {
                                self.years.push({ id: null, label: 'Any', value: null });
                            }

                            self.blockStatuses = res.body.outputData.blockStatuses;
                            self.blockStatuses.unshift({ id: null, label: 'Any', value: null });

                            self.standardTypes = res.body.outputData.standardTypes;
                            self.standardTypes.unshift({ id: null, label: 'Any', value: null });
                        }
                    }
                    else {
                        self.$showError(res && res.body && res.body.message ? res.body.message : null);
                    }
                    self.to_top();
                },
                    err => {
                        self.isProcessing = false;
                        self.$showError(5000);
                    });
        }
    },
    mounted() {
    }
};



// WEBPACK FOOTER //
// ./src/components/admin/club/club-standards/layout/layout.js